import React, { memo, useContext, useEffect, useReducer } from 'react';
import './css/HomePage1Section4.css';
import { useSnackbar } from 'notistack';
import HomePage1Games1 from '../uiElements/homePage1Games/homePage1Games1/HomePage1Games1';
import HomePage1Events1 from '../uiElements/homePage1Events/homePage1Events1/HomePage1Events1';
import HomePage1Practice1 from '../uiElements/homePage1Practice/homePage1Practice1/HomePage1Practice1';
import { context } from '../../../../globalState/GlobalState';
import { fetchLimitedScheduledGamesAPI } from '../../../apiCalls/games/GameAPICalls';
import { fetchLimitedUpcomingEventsAPI } from '../../../apiCalls/EventAPICalls';

const initialState = {
    type: 'game',
    games: [],
    events: [],
    practice: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'setType':
            return { ...state, type: action.buttonType };
        case 'fetchScheduledGames':
            return { ...state, games: action.games };
        case 'fetchUpcomingEvents':
            return { ...state, events: action.events };
        case 'fetchUpcomingPractice':
            return { ...state, practice: action.events };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1Section4 = () => {
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetch() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchLimitedScheduledGamesAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            await fetchLimitedUpcomingEventsAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            // await fetchLimitedUpcomingPracticeAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetch();
    }, []);

    const getContent = () => {
        if (state.type === 'game') {
            return (<HomePage1Games1 games={state.games} scheduled />);
        } if (state.type === 'event') {
            return (<HomePage1Events1 events={state.events} upcoming />);
        } if (state.type === 'practice') {
            return (<HomePage1Practice1 events={state.practice} upcoming />);
        }
        return null;
    };

    return (
        <div className="homepage1-section4-container" style={{ display: state.games.length === 0 && state.events.length === 0 && state.practice.length === 0 ? 'none' : '' }}>
            <div className="homepage1-section4-button-container m-l-70px">
                <>
                    <button type="button" className={`homepage1-section4-button alegreya-font-family font-weight-800 text-left-align font-size-4xl text-uppercase m-r-40px m-b-40px ${state.type === 'game' ? 'homepage1-section4-button-active' : 'homepage1-section4-button-not-active'}`} onClick={() => { setState({ type: 'setType', buttonType: 'game' }); }}>Upcoming Games</button>
                    <button type="button" className={`homepage1-section4-button alegreya-font-family font-weight-800 text-left-align font-size-4xl text-uppercase m-r-40px m-b-40px ${state.type === 'event' ? 'homepage1-section4-button-active' : 'homepage1-section4-button-not-active'}`} onClick={() => { setState({ type: 'setType', buttonType: 'event' }); }}>Events</button>
                    {/* {state.practice.length > 0 ? (<button type="button" className={`homepage1-section4-button alegreya-font-family font-weight-800 text-left-align font-size-4xl text-uppercase m-r-40px m-b-40px ${state.type === 'practice' ? 'homepage1-section4-button-active' : 'homepage1-section4-button-not-active'}`} onClick={() => { setState({ type: 'setType', buttonType: 'practice' }); }}>Practice</button>) : null} */}
                </>
            </div>
            {getContent()}
        </div>
    );
};

export default memo(HomePage1Section4);
